import { render, staticRenderFns } from "./ModularLinkageControl.vue?vue&type=template&id=5050e354&scoped=true&"
import script from "./ModularLinkageControl.vue?vue&type=script&lang=js&"
export * from "./ModularLinkageControl.vue?vue&type=script&lang=js&"
import style0 from "./ModularLinkageControl.vue?vue&type=style&index=0&id=5050e354&prod&lang=scss&scoped=true&"
import style1 from "./ModularLinkageControl.vue?vue&type=style&index=1&id=5050e354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050e354",
  null
  
)

export default component.exports